import { render, staticRenderFns } from "./ProspectDocs.vue?vue&type=template&id=60cac749&"
import script from "./ProspectDocs.vue?vue&type=script&lang=ts&"
export * from "./ProspectDocs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports